module.exports = __webpack_public_path__ + "45c270e1a2c48991e20c26cd021d7f7f.svg";